import React from "react";
import { Award, Leaf, Users, ShieldCheck } from "lucide-react";

const VALUES = [
  {
    icon: Award,
    title: "5.0-Star Rated",
    text: "Every job earns a perfect score. We obsess over the details so you don't have to.",
  },
  {
    icon: Leaf,
    title: "Plant & Pet Safe",
    text: "Biodegradable detergents and soft-wash methods that protect what surrounds your home.",
  },
  {
    icon: Users,
    title: "Local Ohio Crew",
    text: "Family-owned, fully insured, and proud to serve neighborhoods across Ohio.",
  },
  {
    icon: ShieldCheck,
    title: "100% Guarantee",
    text: "If you're not thrilled with the result, we come back. No questions, no charge.",
  },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="py-20 md:py-32 bg-white scroll-mt-20"
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="relative order-2 lg:order-1">
          <div className="relative aspect-[4/5] rounded-3xl overflow-hidden shadow-xl ring-1 ring-slate-900/5">
            <img
              src="https://images.pexels.com/photos/4469156/pexels-photo-4469156.jpeg"
              alt="Beautiful clean Ohio home"
              className="absolute inset-0 h-full w-full object-cover"
            />
          </div>
          <div className="hidden md:block absolute -top-6 -right-6 bg-blue-600 text-white rounded-2xl p-5 shadow-xl">
            <div className="font-display text-4xl font-black leading-none">15+</div>
            <p className="text-xs font-bold uppercase tracking-wider mt-2 opacity-90">
              Years cleaning Ohio
            </p>
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <p className="text-sm font-bold uppercase tracking-[0.2em] text-blue-600">
            About ClearView
          </p>
          <h2 className="font-display mt-3 text-3xl md:text-4xl lg:text-5xl font-extrabold tracking-tight text-slate-900">
            We treat your home like it's our own.
          </h2>
          <p className="mt-5 text-base md:text-lg text-slate-600 font-medium leading-relaxed">
            ClearView started with a simple idea: pressure washing should be
            careful, honest, and built around the customer — not the upsell.
            Every job is led by a trained crew member, every quote is fair, and
            every result is guaranteed.
          </p>

          <div className="mt-8 grid sm:grid-cols-2 gap-5">
            {VALUES.map((v) => (
              <div
                key={v.title}
                data-testid={`value-${v.title.toLowerCase().replace(/\s+/g, "-")}`}
                className="p-5 rounded-2xl bg-slate-50 border border-slate-200"
              >
                <div className="h-9 w-9 rounded-xl bg-blue-600 text-white grid place-items-center mb-3">
                  <v.icon className="h-4 w-4" strokeWidth={2.5} />
                </div>
                <h3 className="font-display font-extrabold text-slate-900 text-base">
                  {v.title}
                </h3>
                <p className="text-sm text-slate-600 mt-1 font-medium leading-relaxed">
                  {v.text}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
